import { SIZE_GUIDE_STATE } from '../Actions/SizeGuide.action';

const DEFAULT_STATE = {
    visible: false,
    customContent: null,
};

export const sizeGuide = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SIZE_GUIDE_STATE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}